export { default } from './InputWithLabel.js';
